var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-shell"},[_c('HeaderBar'),_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid workspace-container"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }